/* Uses GLTFLoader THREEJS example (v0.117.0) */

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

const THREE = require('three');

export const GLTFLoadPromise = (path) => new Promise((resolve, reject) => {
    const manager = new THREE.LoadingManager();
    const loader = new GLTFLoader(manager);

    loader.load(
        path,
        (object) => {
            resolve(object);
        },
        undefined,
        (e) => {
            reject(new Error(`Faild to load '${path} width error ${e}'`));
        }
    );
});
